// styles/base/components/layout.ts

/**
 * Typography variants for sophisticated content presentation
 * Because different contexts deserve different typographical treatments
 */

import { colors } from '../tokens';

export const typographyVariants = {
    variants: [
        {
            props: { variant: 'metricTitle' },
            style: {
                fontWeight: 'bold',
                textAlign: 'center',
                fontSize: '1rem',
                display: 'block',
                marginBottom: '0.35rem',
            },
        },
        {
            props: { variant: 'metricValue' },
            style: {
                fontSize: '1.5rem',
                fontWeight: 'bold',
                textAlign: 'center',
                display: 'block',
            },
        },
        {
            props: { variant: 'chartTitle' },
            style: ({ ownerState }: { ownerState: Record<string, unknown> }) => ({
                fontSize: '1rem',
                color: colors.panelText,
                fontWeight: ownerState.bold === false ? 'normal' : 'bold',
            }),
        },
        {
            props: { variant: 'chartTableRow' },
            style: (_: { ownerState: Record<string, unknown> }) => ({
                fontSize: '1rem',
                color: colors.primary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }),
        },
    ],
};

/**
 * Grid variants for sophisticated layout management
 */
export const gridVariants = {
    variants: [
        {
            props: { variant: 'metricsContainer' },
            style: {
                height: '100%',
                padding: 0,
            },
        },
    ],
};
